import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid, Box } from '@material-ui/core';
import { translate } from 'helpers/intl';
import messages from 'containers/EpargnDetailsPage/messages';
import { sanlamVeryDarkBlue } from 'Material-UI/colors';
import { SizedSmallSectionHeader } from 'containers/AutoDetailsPage/MyContractAndGarantiesTab/KnowMoreAboutContracts/styles';

const Header = (props: { intl: IntlShape }) => {
  return (
    <Box marginBottom={1.25}>
      <Grid justify="space-between" alignItems="center" container>
        <Grid item xs={5}>
          <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
            {translate({ ...messages.releve_situation_title }, props)}
          </SizedSmallSectionHeader>
        </Grid>
      </Grid>
    </Box>
  );
};

export default injectIntl(Header);
